module.exports = __webpack_public_path__ + "static/img/badge-android.da887e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/apps/badge-android.jpg
// module id = 6Wge
// module chunks = 1